    /**
     * SAL1030_R01 - 품목별 수주 현황 조회
     * Content 컴포넌트 (비즈니스 로직 처리)
     */

    import { useCallback } from "react";
    import { getSAL1030_R01List, getSAL1030_R01AllCount, downloadExcel_SAL1030_R01 } from "./Api_SAL1030_R01";
    import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
    import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
    import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
    import { downloadExcel } from "src/utils/blob/blobUtil";
    import { useSAL1030_R01Store } from "./Store_SAL1030_R01";
    import { SAL1030_R01Dto } from "./Dto_SAL1030_R01";

    interface SAL1030_R01ContentProps {
    setMessage: (message: string) => void;
    }

    export const Content_SAL1030_R01 = (props: SAL1030_R01ContentProps) => {
    const { setMessage } = props;

    const { 
        SAL1030_R01Filter,
        SAL1030_R01List, 
        setSAL1030_R01List, 
        setAllCount,
        setScrollTop,
    } = useSAL1030_R01Store();
    
    const { setLoadingSpinner } = useLoadingSpinnerStore();

    useFetchActionbarAuth("SAL1030_R01");

    /**
     * 품목별 수주 현황 데이터 조회
     */
    const fetchData = useCallback(async () => {
        setScrollTop(null);
        setLoadingSpinner(true);
        try {
        // 전체 목록 조회
        const responseData = await getSAL1030_R01List(
            '',
            SAL1030_R01Filter,
            SAL1030_R01List.length || 0
        );
        const newList = [...responseData.data.data] as SAL1030_R01Dto[];
        
        if (newList && newList.length > 0) {
            setSAL1030_R01List(newList);
            
            // 전체 개수 조회
            try {
            const countResponse = await getSAL1030_R01AllCount(SAL1030_R01Filter);
            setAllCount(countResponse.data.data);
            } catch (error) {
            console.warn('전체 개수 조회 실패:', error);
            }
            
            ShowSuccessFetch(
            setMessage, 
            `조회가 완료되었습니다. (총 ${newList.length}건)`
            );
            setTimeout(() => setMessage(""), 5000);
        } else {
            showWarning('데이터가 없습니다.');
            setSAL1030_R01List([]);
            setAllCount(0);
        }
        } catch (error) {
        console.error('데이터 조회 실패:', error);
        showWarning('데이터 조회에 실패했습니다.');
        setSAL1030_R01List([]);
        setAllCount(0);
        } finally {
        setLoadingSpinner(false);
        }
    }, [SAL1030_R01Filter, SAL1030_R01List.length, setSAL1030_R01List, setAllCount, setMessage, setLoadingSpinner, setScrollTop]);

    /**
     * 엑셀 다운로드 (Base64 디코딩)
     */
    const handleExcelClick = useCallback(async () => {
        if (!SAL1030_R01List || SAL1030_R01List.length === 0) {
        showWarning("다운로드할 데이터가 없습니다.");
        return;
        }

        try {
        setLoadingSpinner(true);
        const response = await downloadExcel_SAL1030_R01(
            '',
            SAL1030_R01Filter,
            SAL1030_R01List.length || 0
        );

        // Base64 문자열 → Blob 변환 (SAL2080_R01 패턴)
        const binaryString = atob(response.data.data);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            byteArray[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([byteArray]);
        downloadExcel(blob, '품목별_수주_현황-excel.xlsx');
        } catch (error) {
        console.error('엑셀 다운로드 실패:', error);
        showWarning('엑셀 다운로드에 실패했습니다.');
        } finally {
        setLoadingSpinner(false);
        }
    }, [SAL1030_R01Filter, SAL1030_R01List, setLoadingSpinner]);

    return {
        fetchData,
        handleExcelClick,
    };
    };
